import { env as i } from "@fond-of/env";
const o = {
  de: "de",
  dk: "da",
  en: "en",
  it: "it",
  es: "es",
  fr: "fr"
}, a = "en", d = Object.keys(o), u = Object.values(o), r = ["de"], f = (e) => d.includes(e), P = (e) => u.includes(e), g = (e) => r.includes(e), c = (e) => {
  const n = e || i.isSSR ? "" : window.location.origin;
  return r.find(
    (t) => n.endsWith(`.${t}`)
  );
}, L = (e) => {
  const n = e || i.isSSR ? "" : window.location.pathname, [t, s] = n.split("/");
  return s;
}, v = () => c() ? "/" : `/${m}`, l = () => {
  const e = c(), n = L();
  return e || (f(n) ? n : a);
}, p = () => o[l()], m = l(), z = p();
export {
  z as currentLocale,
  m as currentUrlPrefix,
  a as defaultLocale,
  c as findLocalizedTopLevelDomain,
  p as getCurrentLocale,
  l as getCurrentUrlPrefix,
  v as getLocalizedBaseUrl,
  L as getUrlPrefix,
  P as isValidLocale,
  g as isValidLocalizedTopLevelDomain,
  f as isValidUrlPrefix,
  o as localeMap,
  u as locales,
  r as localizedTopLevelDomains,
  d as urlPrefixes
};
//# sourceMappingURL=locale.js.map
